import React, { memo, useContext } from 'react';
import PropTypes from 'prop-types';
import { context } from '../../../globalState/GlobalState';
import Spinner1 from '../../uiElements/spinners/spinner1/Spinner1';
import BreadCrumbs1 from '../../uiElements/breadCrumbs/breadCrumbs1/BreadCrumbs1';
import TicketComponent1 from '../../uiElements/ticketsComponents/ticketComponent1/TicketComponent1';

const Ticket1 = (props) => {
    const { id, title, shortDescription, featureImage, prices, ticketsTotal, ticketsSold, ticketsHold, eventId, eventTitle, eventType, eventFeatureImage, eventVenue, timeOfEvent, endTimeOfEvent, stripeProductId, published, inStock, deleted, loadingSpinner } = props;
    const { globalState } = useContext(context);

    const getBreadCrumbsLinks = () => {
        return [
            {
                title: 'Home',
                link: '/',
            },
            {
                title: 'Tickets',
                link: '/tickets',
            },
        ];
    };

    return (
        <>
            {loadingSpinner ? <Spinner1 color={globalState.websiteStyles.colors.primaryColor} /> : (
                <>
                    <BreadCrumbs1 links={getBreadCrumbsLinks()} lastCrumb={title} marginLeft="100px" />
                    <TicketComponent1 ticket={{ id, title, shortDescription, featureImage, prices, ticketsTotal, ticketsSold, ticketsHold, eventId, eventTitle, eventType, eventFeatureImage, eventVenue, timeOfEvent, endTimeOfEvent, stripeProductId, published, inStock, deleted }} loadingSpinner={loadingSpinner} />
                </>
            )}
        </>
    );
};

Ticket1.propTypes = {
    id: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    shortDescription: PropTypes.string.isRequired,
    featureImage: PropTypes.string.isRequired,
    prices: PropTypes.array.isRequired,
    ticketsTotal: PropTypes.number.isRequired,
    ticketsSold: PropTypes.number.isRequired,
    ticketsHold: PropTypes.number.isRequired,
    eventId: PropTypes.string.isRequired,
    eventTitle: PropTypes.string.isRequired,
    eventType: PropTypes.number.isRequired,
    eventFeatureImage: PropTypes.string.isRequired,
    eventVenue: PropTypes.string.isRequired,
    timeOfEvent: PropTypes.any.isRequired,
    endTimeOfEvent: PropTypes.any.isRequired,
    stripeProductId: PropTypes.string.isRequired,
    inStock: PropTypes.bool.isRequired,
    published: PropTypes.bool.isRequired,
    deleted: PropTypes.bool.isRequired,
    loadingSpinner: PropTypes.bool.isRequired,
};

export default memo(Ticket1);
